// extracted by mini-css-extract-plugin
module.exports = {"logoImg":"_85065db"};